import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/nav/nav-form.svg'
import _imports_1 from '@/assets/nav/new-quiz.svg'
import _imports_2 from '@/assets/nav/home-fill.svg'
import _imports_3 from '@/assets/nav/home.svg'
import _imports_4 from '@/assets/nav/search-fill.svg'
import _imports_5 from '@/assets/nav/search.svg'
import _imports_6 from '@/assets/nav/stats-fill.svg'
import _imports_7 from '@/assets/nav/stats.svg'
import _imports_8 from '@/assets/nav/profile-fill.svg'
import _imports_9 from '@/assets/nav/profile.svg'


const _hoisted_1 = {
  key: 0,
  class: "mobile-nav"
}
const _hoisted_2 = { class: "mobile-nav__form" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "img-form" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "mobile-nav__links" }
const _hoisted_7 = {
  key: 0,
  class: "fade-in",
  src: _imports_2
}
const _hoisted_8 = {
  key: 1,
  src: _imports_3
}
const _hoisted_9 = {
  key: 0,
  class: "fade-in",
  src: _imports_4
}
const _hoisted_10 = {
  key: 1,
  src: _imports_5
}
const _hoisted_11 = {
  key: 0,
  class: "fade-in",
  src: _imports_6
}
const _hoisted_12 = {
  key: 1,
  src: _imports_7
}
const _hoisted_13 = {
  key: 0,
  class: "fade-in",
  src: _imports_8
}
const _hoisted_14 = {
  key: 1,
  src: _imports_9
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLogged)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: "img-new-quiz",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createQuiz && _ctx.createQuiz(...args)))
          }, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "link-home link",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
          }, [
            (_ctx.currentView === 'Home')
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : (_openBlock(), _createElementBlock("img", _hoisted_8))
          ]),
          _createElementVNode("div", {
            class: "link-search link",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goSearch && _ctx.goSearch(...args)))
          }, [
            (_ctx.currentView === 'Search')
              ? (_openBlock(), _createElementBlock("img", _hoisted_9))
              : (_openBlock(), _createElementBlock("img", _hoisted_10))
          ]),
          _createElementVNode("div", {
            class: "link-stats link",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goStats && _ctx.goStats(...args)))
          }, [
            (_ctx.currentView === 'Stats')
              ? (_openBlock(), _createElementBlock("img", _hoisted_11))
              : (_openBlock(), _createElementBlock("img", _hoisted_12))
          ]),
          _createElementVNode("div", {
            class: "link-profile link",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goProfile && _ctx.goProfile(...args)))
          }, [
            (_ctx.currentView === 'Profile')
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : (_openBlock(), _createElementBlock("img", _hoisted_14))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}